<template ref="foo">
  <div class="white-wrapper">
    <div class="row">
      <div class="col-12">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex">
            <h6 class="mb-0">{{ screenDetails.screen_name }}</h6>
            <!-- <div class="mx-2">|</div>
            <h6 class="mb-0 font-weight-bold">A1</h6>-->
          </div>
          <!-- <div class="d-flex">
            <div class="px-3">
              <div class="input-material">
                <input
                  @change="onChangeRowsColumns()"
                  v-model="rows"
                  type="number"
                  required="required"
                />
                <label>Rows</label>
              </div>
            </div>

            <div>
              <div class="input-material">
                <input
                  v-on:change="onChangeRowsColumns()"
                  v-model="columns"
                  type="number"
                  required="required"
                />
                <label>columns</label>
              </div>
            </div>
          </div>-->
        </div>
      </div>

      <div class="col-12">
        <header class="cinema-header">
          <div class="row justify-content-between">
            <div class>
              <div class="d-flex justify-content-end">
                <div
                  v-for="(seatType, seatTypeIndex) in seatTypes"
                  :key="seatTypeIndex"
                  class="mx-1 mx-xl-3"
                  v-on:click="selectSeatType(seatType)"
                >
                  <div
                    :class="
                      seatTypeSelected == seatType &&
                      seatTypeSelectionMode == 'seatType'
                        ? 'selected_seat_type_active'
                        : ''
                    "
                    v-if="seatType.imageURL"
                    class="cinema-seat my-0 mx-auto bg-blue"
                  >
                    <img :src="seatType.imageURL" height="28" width="27" />
                  </div>
                  <div
                    v-else
                    :class="
                      seatTypeSelected == seatType &&
                      seatTypeSelectionMode == 'seatType'
                        ? `selected_seat_type_active ${seatType.imageClass}`
                        : `${seatType.imageClass}`
                    "
                    class="cinema-seat my-0 mx-auto bg-blue"
                  >
                  </div>
                  <small>{{ seatType.seatName }}</small>
                </div>

                <!-- <div class="divider mx-1 mx-xl-3"></div> -->
              </div>
            </div>
          </div>
        </header>
        <div class="row mt-3 mx-0">
          <div
            v-for="(singleScreenType, singleScreenTypeIndex) in screenSeatTypes"
            :key="'singleScreenType' + singleScreenTypeIndex"
            class="mx-1"
          >
            <b-button
              variant="default"
              class="btn-outline-blue"
              v-on:click="selectScreenSeatType(singleScreenType)"
              :style="{
                borderColor: singleScreenType.sst_seat_color_code,
                backgroundColor: singleScreenType.sst_seat_color_code,
                color: 'white',
              }"
              >{{ singleScreenType.sst_seat_type }} -
              {{ singleScreenType.sst_no_of_seats }} seat(s)</b-button
            >
            <!-- <div>{{singleScreenType.sst_seat_type}}</div> -->
          </div>
          <!-- 
                <div class="mx-1">
                  <b-button variant="default" class="btn-outline-blue">Silver</b-button>
                </div>

                <div class="mx-1">
                  <button class="btn-outline-blue">Premium</button>
          </div>-->

          <div class="mx-1">
            <button
              v-on:click="showName = !showName"
              :class="showName ? 'btn-blue px-2' : 'btn-outline-blue px-2'"
            >
              Show {{ showName ? "Grid" : "Name" }}
            </button>
          </div>
          <div class="mx-1 pr-3">
            <div class="d-flex align-items-center mb-5">
              <span>{{ $t("isPermanentBroken") }}</span>
              <b-form-checkbox
                class="ml-3"
                v-model="isPermanentBroken"
                unchecked-value="N"
                @change="onChangeSwitch($event)"
                value="Y"
                switch
              ></b-form-checkbox>
            </div>
          </div>

          <div v-if="isPermanentBroken == 'N'" class="mx-1">
            <div class="input-material">
              <div class="add-datepicker">
                <datetime
                  v-model="fromTime"
                  type="datetime"
                  class="theme-custom-date-time"
                  format="yyyy-MM-dd hh:mm:ss a"
                  use12-hour
                ></datetime>
                <label class="active"
                  >{{ $t("repair") }} {{ $t("start") }} {{ $t("time") }}</label
                >
              </div>
            </div>
          </div>
          <div v-if="isPermanentBroken == 'N'" class="mx-1">
            <div class="input-material">
              <div class="add-datepicker">
                <datetime
                  v-model="endTime"
                  type="datetime"
                  class="theme-custom-date-time"
                  format="yyyy-MM-dd hh:mm:ss a"
                  use12-hour
                ></datetime>
                <label class="active"
                  >{{ $t("repair") }} {{ $t("end") }} {{ $t("time") }}</label
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 mt-3">
        <div class="selected-option">
          <span class="fs-16 font-weight-bold">Selected Option:</span>&nbsp;
          {{
            seatTypeSelectionMode == "screenSeatType" && screenSeatTypeSelected
              ? screenSeatTypeSelected.sst_seat_type
              : seatTypeSelected
              ? seatTypeSelected.seatName
              : ""
          }}
        </div>
        <div class="selected-option" v-if="seatTypeSelectionMode == 'seatType'">
          <span class="fs-16 font-weight-bold">Capacity:</span>&nbsp;
          {{ seatTypeSelected ? seatTypeSelected.size : 1 }}
        </div>
      </div>

      <div class="col-12">
        <h5 class="text-center pt-3">All Eyes This Way</h5>
        <div
          class="cinema-seatlayout"
          onmousedown="vmVue.$emit('mouseKeyDown', 'test')"
          onmouseup="vmVue.$emit('mouseKeyUp', 'test')"
        >
          <table class="generateSeatLayout">
            <!-- REGULAR SEATS -->

            <!-- SLIVER CLASS LABEL -->
            <!-- <tr>
                <td colspan="22">
                  <b-button variant="default" class="btn-blue mb-3">View Seat No.</b-button>
                </td>
            </tr>-->

            <!-- <tr>
                  <td>
                    <div  class="text-center lh-1">0</div>
                  </td>
                  <td>
                    <div class="cinema-seatNumber">1</div>
                     <div v-on:click="onClickSeat()" class="pos-seat"></div>
                  </td>
                  <td>
                      <div class="cinema-seatNumber">2</div>
                     <div v-on:click="onClickSeat()" class="pos-seat"></div>
                  </td>
                   <td v-for="(loop , regularSeats) in 18+3" :key="regularSeats" v-if="regularSeats >=3">
                     <div class="cinema-seatNumber">{{regularSeats}}</div>
                    <div  class="cinema-seat"></div>
                  </td>
                  <td>
                    <div  class="text-center lh-1">0</div>
                  </td>
            </tr>-->

            <tr v-for="(row, rowIndex) in seats" :key="rowIndex">
              <td>
                <div class="cinema-seatNumber">{{ row.rowName }}</div>
                <input
                  v-if="showName"
                  type="text"
                  class="changeSeatName"
                  v-model="seats[rowIndex].rowName"
                  @change="changeRowName()"
                />
              </td>
              <td
                v-for="(column, columnIndex) in row.singleRow"
                :key="'singleSeat' + columnIndex + 1"
                colspan="1"
              >
                <!-- {{ seats[rowIndex].singleRow[columnIndex].seatType ? true : '' }} -->
                <div class="cinema-seatNumber">{{ columnIndex + 1 }}</div>
                <div
                  v-if="
                    !showName &&
                      seats[rowIndex] &&
                      seats[rowIndex].singleRow[columnIndex]
                  "
                  @mousedown="mouseDownOnSeat(columnIndex, rowIndex)"
                  @mouseover="
                    !checkMouseOver()
                      ? mouseOverSeat(columnIndex, rowIndex)
                      : null
                  "
                  @click="
                    checkMouseOver()
                      ? mouseOverSeat(columnIndex, rowIndex)
                      : null
                  "
                  class="cinema-seat"
                  :style="{
                    borderColor:
                      seats[rowIndex].singleRow[columnIndex].screenSeatType
                        .sst_seat_color_code,
                    backgroundColor:
                      seats[rowIndex].singleRow[columnIndex].screenSeatType
                        .sst_seat_color_code,
                  }"
                  :class="
                    seats[rowIndex].singleRow[columnIndex].seatType &&
                    seats[rowIndex].singleRow[columnIndex].seatType.imageURL
                      ? ''
                      : seats[rowIndex].singleRow[columnIndex].seatType &&
                        seats[rowIndex].singleRow[columnIndex].seatType
                          .imageClass
                  "
                >
                  <img
                    v-if="
                      seats[rowIndex].singleRow[columnIndex].seatType.imageURL
                    "
                    :src="
                      seats[rowIndex].singleRow[columnIndex].seatType.imageURL
                    "
                    height="28"
                    width="27"
                  />
                </div>
                <input
                  v-if="showName"
                  type="text"
                  class="changeSeatName"
                  v-model="seats[rowIndex].singleRow[columnIndex].seatName"
                />
              </td>

              <td>
                <div class="cinema-seatName">{{ row.rowName }}</div>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div class="col-12 py-2 text-center">
        <!-- to="add-seat-layout" -->
        <b-button
          :disabled="btenable"
          variant="default"
          v-on:click="submitBrokenSeats()"
          class="btn-blue"
          >{{ $t("update") }}</b-button
        >
        <b-button variant="default" @click="reload()" class="btn-black"
          >Reset</b-button
        >
        <b-button
          variant="default"
          @click="goToRoute()"
          class="btn-outline-grey"
          >Cancel</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import ScreenService from "@/services/ScreenService";
import MasterService from "@/services/MasterService";
import { groupBy } from "lodash";
import { decryptString } from "@/helper/collection"

var thing = {
  data() {
    return {
      btenable: false,
      screenDetails: {
        screen_name: null,
      },
      showName: false,
      screenId: null,
      screenSeatTypes: [],
      seatTypeSelected: {
        seatName: "regularSeat",
        size: 1,
        value: 1,
        imageClass: "regular-seat",
      },
      mouseDownStatus: false,
      initialSeatValueSelected: {
        row: 0,
        column: 0,
      },
      screenSeatTypeSelected: {},
      seatTypeSelectionMode: "seatType",
      finalSeatValueSelected: {
        row: 0,
        column: 0,
      },
      seatTypes: [
        {
          seatName: "Regular Seat",
          size: 1,
          value: 1,
          imageClass: "regular-seat",
          imageURL: "",
        },
        {
          seatName: "No Seat",
          size: 1,
          value: 2,
          imageClass: "no-seat",
          imageURL: "",
        },
        {
          seatName: "Wheel Chair",
          size: 1,
          value: 3,
          imageClass: "wheelchair",
          imageURL: "",
        },
        {
          seatName: "VIP Seat",
          size: 1,
          value: 5,
          imageClass: "vip-seat",
          imageURL: "",
        },
        // {
        //   seatName: "Couple Seats",
        //   size: 6,
        //   imageClass: "love-seat",
        // },
        {
          seatName: "Only POS",
          size: 1,
          value: 9,
          imageClass: "pointofsale",
          imageURL: "",
        },
        {
          seatName: "Sofa",
          size: 1,
          value: 10,
          imageClass: "sofa-seat",
          imageURL: "",
        },
        {
          seatName: "Recliner",
          size: 1,
          value: 11,
          imageClass: "recliner",
          imageURL: "",
        },
        // {
        //   seatName: "Blocked Seat",
        //   size: 1,
        //   value: 12,
        //   imageClass: "block-seat",
        // },
        {
          seatName: "Broken Seat",
          size: 1,
          value: 13,
          imageClass: "broken-seat",
          imageURL: "",
        },
      ],
      rows: 10,
      columns: 10,
      seats: [],
      finalSeatValueSelected: {
        row: 0,
        column: 0,
      },

      //
      isPermanentBroken: "Y",
      fromTime: "",
      endTime: "",
      brokenSeats: [],
      isReversedRow: false,
      isReversedRowName: false,
      isReversed: true,
      activeSeatTypes: [],
        currentCinemaId: null
      // "vipSeat", "regularSeat", "NoSeat", "WheelChair"],
    };
  },
  beforeMount() {
    // this.onChangeRowsColumns();
     const { cinema_id = null } = this.$route.query;
      if (!cinema_id) {
        this.$toasted.show("Cinema is missing")
        this.$router.push("/cinema-manager/screens")
      }
      this.currentCinemaId = decryptString(String(cinema_id))
    this.getSeatTypes();
    this.screenId = this.$route.params.screenID;
    this.getSeatScreenType();
  },
  mounted() {
    vmVue.$on("mouseKeyDown", this.mouseDown);
    vmVue.$on("mouseKeyUp", this.mouseUp);
  },
  methods: {
    checkMouseOver() {
      if (
        this.seatTypeSelected &&
        this.seatTypeSelected.hasOwnProperty("size") &&
        this.seatTypeSelected.size > 1
      ) {
        return true;
      } else {
        return false;
      }
    },
    getSeatTypes: function(screen) {
      let payload = {
        tableName: "ms_seat_reserve_types",
        srt_is_active: "Y",
      };
      this.seatTypes = [];
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.activeSeatTypes = data.Records;
            this.activeSeatTypes.map((x) => {
              let obj = {
                seatName: x.srt_name,
                size: x.srt_seat_capacity,
                value: x.srt_id,
                imageClass: "regular-seat",
                imageURL: this._GetImagePath(x.srt_dash_image_url),
              };
              if (x.srt_id == 1) {
                this.seatTypeSelected = obj;
              }
              this.seatTypes.push(obj);
            });
          } else {
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("Catch Error :", error);
        });
    },
    reload() {
      this.brokenSeats = [];
      // location.reload();
      this.getSeatLayout();
    },
    goToRoute: function() {
      this.$router.go(-1);
    },
    onReverseOrder: function() {
      console.log(this.seats);
      if (this.isReversedRowName) {
        this.seats.sort(function(a, b) {
          return b.rowName.localeCompare(a.rowName);
        });
      } else {
        this.seats.sort(function(a, b) {
          return a.rowName.localeCompare(b.rowName);
        });
      }
      this.isReversedRowName = !this.isReversedRowName;
    },
    onChangeSwitch: function(event) {
      console.log(event);
    },
    changeRowName: function() {
      this.isReversedRow = false;
      this.isReversedRowName = false;
      let newSeats = this.seats;
      this.seats = [];

      for (let i = 0; i < newSeats.length; i++) {
        let seatRow = [];
        let z = 0;
        for (let j = 0; j < newSeats[0].singleRow.length; j++) {
          let singleSeat = newSeats[i].singleRow[j];

          if (singleSeat.seatType.value == 2) {
            singleSeat.seatName = "";
          } else {
            singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
            z++;
          }

          seatRow.push(singleSeat);
        }
        this.seats.push({
          rowName: newSeats[i].rowName,
          singleRow: seatRow,
        });
        this.seatsCopy.push({
          rowName: newSeats[i].rowName,
          singleRow: seatRow,
        });
      }
    },
    getSeatScreenType: function() {
      let payload = {
        screenID: this.screenId,
        cinema_id:this.currentCinemaId
      };
      ScreenService.getSeatScreenType(payload)
        .then((result) => {
          const { data } = result;
          if (data.status && data.Records.length > 0) {
            this.screenSeatTypes = data.Records;
            this.getSeatLayout();
          }
        })
        .catch((err) => {});
    },
    getSeatLayout: function() {
      this.seats = [];
      let payload = {
        screenID: this.screenId,
        cinema_id:this.currentCinemaId
      };
      ScreenService.getSeatLayout(payload)
        .then((result) => {
          // console.log("result :", result);
          const { data } = result;
          if (data.status && data.Records.screen_layouts.length > 0) {
            this.screenDetails =
              data.Records["screenDetails"] &&
              data.Records.screenDetails.length > 0
                ? data.Records.screenDetails[0]
                : this.screenDetails;

            let seatData_1 = groupBy(data.Records.screen_layouts, "sl_row_num");
            console.log(seatData_1, "sdfdsfsdf");

            for (let key in seatData_1) {
              if (seatData_1.hasOwnProperty(key)) {
                let num = 0;
                let letr = "a";
                let check = 0;
                let seatData_2 = seatData_1[key].map((singleSeat) => {
                  if (
                    singleSeat.sl_seat_name != "" &&
                    singleSeat.sl_seat_name != null &&
                    check == 0
                  ) {
                    num = singleSeat.sl_seat_name.match(/\d+/g)[0];
                    letr =
                      singleSeat.sl_seat_name.match(/[a-zA-Z]+/g) &&
                      singleSeat.sl_seat_name.match(/[a-zA-Z]+/g).length > 0
                        ? singleSeat.sl_seat_name.match(/[a-zA-Z]+/g)[0]
                        : singleSeat.sl_seat_name.includes("-")
                        ? singleSeat.sl_seat_name.split("-")[0] + "-"
                        : "";
                    check++;
                  }
                  singleSeat["seatName"] = singleSeat.sl_seat_name;
                  this.seatTypes.map((x) => {
                    if (x.value == singleSeat.seat_reserve_type_id) {
                      singleSeat["seatTypeImageClass"] = x.imageClass;
                      singleSeat["imageURL"] = x.imageURL;
                      singleSeat["seatType"] = x;
                    }
                    this.screenSeatTypes.map((y) => {
                      if (y.sst_id == singleSeat.screen_seat_type_id) {
                        singleSeat["screenSeatType"] = y;
                      }
                    });
                  });
                  return singleSeat;
                });

                if (parseInt(num) > 1) {
                  this.isReversedRow = true;
                }

                if (letr.toLowerCase() == "a") {
                  this.isReversedRowName = false;
                } else {
                  this.isReversedRowName = true;
                }

                this.seats.push({
                  rowName: letr,
                  singleRow: seatData_2,
                });
                console.log(this.seats);
                // this.onChangeRowsColumns();
              }
            }
            // this.seats = data.data;
          } else {
            // SHOW ERROR:
            console.log(
              "data.message || `Please try again` :",
              data.message || `Please try again`
            );
          }
        })
        .catch((err) => {});
    },
    onChangeRowsColumns: function() {
      this.isReversedRow = false;
      this.isReversedRowName = false;
      console.log("test");
      this.seats = [];
      var seatRow = [];
      this.seatsCopy = [];
      for (let i = 0; i < this.rows; i++) {
        seatRow = {
          singleRow: [],
          rowName: String.fromCharCode(i + 65),
        };
        for (let j = 0; j < this.columns; j++) {
          let screenSeatType = {
            sst_id: 0,
            sst_seat_color_code: "#000000",
          };
          seatRow.singleRow.push({
            screenSeatType: screenSeatType, //this.screenSeatTypes[0],
            seatType: {
              seatName: "regularSeat",
              size: 1,
              value: 1,
              imageClass: "regular-seat",
            },
            seatTypeImageClass: "normal-seat",
            seatName: seatRow.rowName + parseInt(j + 1),
            anyOtherData: "test",
          });
        }
        this.seats.push(seatRow);
        this.seatsCopy.push(seatRow);
        console.log("this.seatdwvwtrfyewiuhe872t872y92uw92w9s,", this.seats);
      }
      // console.log(this.seats, seatRow);

      // for (let i = 0; i++; i < this.rows) {
      //   for (let j = 0; j++; j < this.columns) {
      //     seats[i][j] = {
      //       seatType: "normal",
      //       anyOtherData: "test"
      //     };
      //   }
      // }
    },
    selectSeatType: function(seatType) {
      console.log({ seatType });
      this.seatTypeSelected = seatType;
      this.seatTypeSelectionMode = "seatType";
    },
    submitBrokenSeats: function() {
      if (this.brokenSeats.length == 0) {
        this.$toasted.show("Please select atleast one broken seat(s)");
        return;
      } else if (
        this.isPermanentBroken == "N" &&
        (String(this.fromTime).length == 0 || String(this.endTime).length == 0)
      ) {
        this.$toasted.show("Please select From date & To date.");
        return;
      } else {
        let self = this;
        let allSeats = [];
        self.btenable = true;
        let payload = {
          is_permanent: self.isPermanentBroken,
          broken_seats: self.brokenSeats,
          from_time: self.fromTime,
          end_time: self.endTime,
          screen_id: self.screenId,
          cinema_id:this.currentCinemaId
        };
        ScreenService.submitBrokenSeatLayout(payload)
          .then((response) => {
            self.btenable = false;
            const { data } = response;
            if (data.status) {
              self.$toasted.show(data.message);
              self.$router.go(-1);
            } else {
              self.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            self.$toasted.show("Error in Submit ", error);
          });
      }
    },
    selectScreenSeatType: function(seatScreenType) {
      this.screenSeatTypeSelected = seatScreenType;
      this.seatTypeSelectionMode = "screenSeatType";
    },
    mouseDown: function() {
      this.mouseDownStatus = true;

      // this.mouseOverSeat(seatColumnSelected, seatRowSelected, true);
    },
    mouseUp: function() {
      this.mouseDownStatus = false;
    },
    mouseDownOnSeat: function(seatColumnSelected, seatRowSelected) {
      this.initialSeatValueSelected.column = seatColumnSelected;
      this.initialSeatValueSelected.row = seatRowSelected;
      this.mouseOverSeat(seatColumnSelected, seatRowSelected, true);
    },
    mouseOverSeat: function(seatColumnSelected, seatRowSelected, clickStatus) {
      let count = 0;
      if (!clickStatus) {
        this.finalSeatValueSelected.column = seatColumnSelected;
        this.finalSeatValueSelected.row = seatRowSelected;
      }
      if (this.mouseDownStatus || clickStatus == true) {
        let newSeats = this.seats;

        this.seats = [];
        for (let i = 0; i < newSeats.length; i++) {
          let seatRow = [];
          let z = 0;
          console.log({ newSeats });
          for (let j = 0; j < newSeats[0].singleRow.length; j++) {
            if (this.seatTypeSelected.value == 13) {
              // this.$refs["date_time_picker"].open();
              // console.log("row=", i, "column", j, seatRow, seatColumn);
              //Do math to select between final and initial row && final and initial column

              if (seatRowSelected == i && seatColumnSelected == j) {
                if (this.seatTypeSelectionMode == "screenSeatType") {
                  // console.log(
                  //   "object :",
                  //   newSeats[i][j],
                  //   this.screenSeatTypeSelected
                  // );
                  let singleSeat = {
                    seatType: newSeats[i].singleRow[j].seatType, //normal, wheelchair, empty
                    screenSeatType: this.screenSeatTypeSelected,
                    seatTypeImageClass: this.seatTypeSelected.imageClass,
                    seatName: newSeats[i].singleRow[j].seatName,
                    anyOtherData: "test1",
                  };
                  if (
                    newSeats[i].singleRow[j].seatType &&
                    newSeats[i].singleRow[j].seatType["value"] &&
                    newSeats[i].singleRow[j].seatType.value == 2
                  ) {
                    singleSeat.seatName = "";
                  } else {
                    singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
                    z++;
                  }
                  let brokenSeatsId = {
                    sl_id: newSeats[i].singleRow[j].sl_id,
                    isBroken: this.seatTypeSelected.value == 1 ? "N" : "Y",
                    seatTypeValue: 13,
                  };

                  console.log(
                    brokenSeatsId,
                    newSeats[i].singleRow[j].sl_id,
                    "fsdfdsfds33"
                  );
                  if (brokenSeatsId.sl_id != undefined) {
                    let filterCheck = this.brokenSeats.findIndex((x) => {
                      return x.sl_id == brokenSeatsId.sl_id;
                    });
                    if (filterCheck < 0) {
                      this.brokenSeats.push(brokenSeatsId);
                    }
                  }
                  seatRow.push(singleSeat);

                  //create
                } else {
                  console.log("3334455");
                  // console.log("object1 :", newSeats[i][j]);
                  let singleSeat = {
                    seatType: this.seatTypeSelected, //normal, wheelchair, empty
                    screenSeatType: newSeats[i].singleRow[j].screenSeatType,
                    seatTypeImageClass: this.seatTypeSelected.imageClass,
                    seatName: newSeats[i].singleRow[j].seatName,
                    anyOtherData: "test2",
                    sl_id: newSeats[i].singleRow[j].sl_id,
                  };
                  if (this.seatTypeSelected.value == 2) {
                    singleSeat.seatName = "";
                  } else {
                    singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
                    z++;
                  }
                  let brokenSeatsId = {
                    sl_id: newSeats[i].singleRow[j].sl_id,
                    isBroken: this.seatTypeSelected.value == 1 ? "N" : "Y",
                    seatTypeValue: 13,
                  };

                  console.log(
                    brokenSeatsId,
                    newSeats,
                    i,
                    j,
                    newSeats[i].singleRow[j].sl_id,
                    "fsdfdsfds"
                  );

                  if (brokenSeatsId.sl_id != undefined) {
                    let filterCheck = this.brokenSeats.findIndex((x) => {
                      return x.sl_id == brokenSeatsId.sl_id;
                    });
                    if (filterCheck < 0) {
                      this.brokenSeats.push(brokenSeatsId);
                    }
                  }

                  seatRow.push(singleSeat);
                }
              } else {
                let singleSeat = newSeats[i].singleRow[j];
                if (this.seatTypeSelectionMode == "screenSeatType") {
                  if (
                    newSeats[i].singleRow[j].seatType &&
                    newSeats[i].singleRow[j].seatType["value"] &&
                    newSeats[i].singleRow[j].seatType.value == 7
                  ) {
                    singleSeat.seatName = "";
                  } else {
                    singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
                    z++;
                  }
                } else {
                  if (
                    singleSeat.seatType &&
                    singleSeat.seatType["value"] &&
                    singleSeat.seatType.value == 2
                  ) {
                    singleSeat.seatName = "";
                  } else {
                    singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
                    z++;
                  }
                }

                seatRow.push(singleSeat);
              }
              // console.log(this.seats, seatRow);
            } else if (this.seatTypeSelected.value) {
              if (
                seatRowSelected == i &&
                seatColumnSelected == j &&
                newSeats[i].singleRow[j].seatType.value == 13
              ) {
                if (this.seatTypeSelectionMode == "screenSeatType") {
                  let singleSeat = {
                    seatType: newSeats[i].singleRow[j].seatType, //normal, wheelchair, empty
                    screenSeatType: this.screenSeatTypeSelected,
                    seatTypeImageClass: this.seatTypeSelected.imageClass,
                    seatName: newSeats[i].singleRow[j].seatName,
                    anyOtherData: "test1",
                    sl_id: newSeats[i].singleRow[j].sl_id,
                  };
                  console.log({ singleSeat });
                  if (
                    newSeats[i].singleRow[j].seatType &&
                    newSeats[i].singleRow[j].seatType["value"] &&
                    newSeats[i].singleRow[j].seatType.value == 2
                  ) {
                    singleSeat.seatName = "";
                  } else {
                    singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
                    z++;
                  }

                  let brokenSeatIndex = this.brokenSeats.findIndex(
                    (seatsObj) => {
                      return seatsObj.sl_id == newSeats[i].singleRow[j].sl_id;
                    }
                  );

                  if (brokenSeatIndex < 0) {
                    this.brokenSeats.push({
                      sl_id: newSeats[i].singleRow[j].sl_id,
                      isBroken: "N",
                      seatTypeValue: this.seatTypeSelected.value,
                    });
                  } else {
                    this.brokenSeats[brokenSeatIndex]["isBroken"] = "N";
                    this.brokenSeats[brokenSeatIndex][
                      "seatTypeValue"
                    ] = this.seatTypeSelected.value;
                  }
                  seatRow.push(singleSeat);
                } else {
                  let singleSeat = {
                    seatType: this.seatTypeSelected, //normal, wheelchair, empty
                    screenSeatType: newSeats[i].singleRow[j].screenSeatType,
                    seatTypeImageClass: this.seatTypeSelected.imageClass,
                    seatName: newSeats[i].singleRow[j].seatName,
                    anyOtherData: "test2",
                    sl_id: newSeats[i].singleRow[j].sl_id,
                  };
                  if (this.seatTypeSelected.value == 2) {
                    singleSeat.seatName = "";
                  } else {
                    singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
                    z++;
                  }
                  let brokenSeatsId = {
                    sl_id: newSeats[i].singleRow[j].sl_id,
                    isBroken: "N",
                    seatTypeValue: this.seatTypeSelected.value,
                  };

                  if (brokenSeatsId.sl_id != undefined) {
                    let filterCheck = this.brokenSeats.findIndex((x) => {
                      return x.sl_id == brokenSeatsId.sl_id;
                    });
                    if (filterCheck < 0) {
                      this.brokenSeats.push(brokenSeatsId);
                    } else {
                      this.brokenSeats[filterCheck]["isBroken"] = "N";
                      this.brokenSeats[filterCheck][
                        "seatTypeValue"
                      ] = this.seatTypeSelected.value;
                    }
                  }

                  seatRow.push(singleSeat);
                }
              } else {
                let singleSeat = newSeats[i].singleRow[j];
                if (this.seatTypeSelectionMode == "screenSeatType") {
                  if (
                    newSeats[i].singleRow[j].seatType &&
                    newSeats[i].singleRow[j].seatType["value"] &&
                    newSeats[i].singleRow[j].seatType.value == 7
                  ) {
                    singleSeat.seatName = "";
                  } else {
                    singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
                    z++;
                  }
                } else {
                  if (
                    singleSeat.seatType &&
                    singleSeat.seatType["value"] &&
                    singleSeat.seatType.value == 2
                  ) {
                    singleSeat.seatName = "";
                  } else {
                    singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
                    z++;
                  }
                }

                seatRow.push(singleSeat);
              }
            } else {
              let singleSeat = {
                seatType: newSeats[i].singleRow[j].seatType, //normal, wheelchair, empty
                screenSeatType: newSeats[i].singleRow[j].screenSeatType,
                seatTypeImageClass: newSeats[i].singleRow[j].imageClass,
                seatName: newSeats[i].singleRow[j].seatName,
                anyOtherData: "test1",
              };

              seatRow.push(singleSeat);
              count++;
            }
          }

          // this.seats.push(seatRow);
          this.seats.push({
            rowName: newSeats[i].rowName,
            singleRow: seatRow,
          });
        }
        console.log("count :>> ", count);
        // this.$set(this.items, indexOfItem, newValue)
      }
      console.log(this.brokenSeats);

      if (count > 0) {
        count = 0;
        this.$toasted.show("Please select broken seat only.");
      }
    },
  },
};
global.thing = thing;
export default thing;
</script>
<style>
.selected_seat_type_active {
  box-shadow: 0px 2px 5px 1px #e41c1c;
}
.selected_screen_type_active {
  box-shadow: 0px 2px 5px 1px #e41c1c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/CinemaSeatLayoutComponents/brokenSeatLayout.vue